import { render, staticRenderFns } from "./equipment6.vue?vue&type=template&id=164209b4&scoped=true"
import script from "./equipment6.vue?vue&type=script&lang=js"
export * from "./equipment6.vue?vue&type=script&lang=js"
import style0 from "./equipment6.vue?vue&type=style&index=0&id=164209b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164209b4",
  null
  
)

export default component.exports